export const altform = {
	mounted() {
		this.update();
	},
	methods: {
		resize() {
			this.$bus.$emit('transitionSlideLayout');
		},
		update() {
			this.$emit('update', this.getFieldData());
		},
		handleSubmit() {
			this.update();
			this.$emit('submit');
		},
		getFieldData() {
			return {};
		},
		getFields() {
			const supportFields = this.$get('provider.supports.fields', []) || [];

			const fields = {};
			supportFields.forEach((f) => {
				fields[f.id] = f;
			});

			return fields;
		},
	},
};
